import React from 'react'



import f1 from '/web frontend/projekty React/oldboy/src/img/char2.jpg'
import f2 from '/web frontend/projekty React/oldboy/src/img/char3.jpg'
import f3 from '/web frontend/projekty React/oldboy/src/img/char4.jpg'
import f4 from '/web frontend/projekty React/oldboy/src/img/char5.jpg'
import f5 from '/web frontend/projekty React/oldboy/src/img/charytatywny.jpg'

function opisCharytatywny() {
  return (
    <>
    <div className='charytatywny-container'> Mecz Charytatywny 2024
    <img src={f5} alt='d'></img>
    <img src={f2} alt='d'></img>
    <img src={f3} alt='d'></img>
    <img src={f4} alt='d'></img>
    <img src={f1} alt='d'></img>
    </div>

    </>
  )
}

export default opisCharytatywny